$(document).ready(function () {
    $('#search-form').on('submit', function (e) {
        if (!$('#search-city').val()) {
            return false;
        }
    });

    $(document).on('keyup', '#search-city', function () {
        this.value ? $('#clear-search').show() : $('#clear-search').hide();
    });

    $('#clear-search').on('click', function () {
        $(this).hide();
        $('#search-city').val('');
        $('#address').val('');
        $("input[name=lat]").val('');
        $("input[name=lng]").val('');
    });

    var swiperParams = {
        speed: 600,
        setWrapperSize: false,
        autoplay: {
            delay: 5000,
        },
        grabCursor: true,
        slidesPerView: 1,
        wrapperClass: 'swiper-wrapper',
        slideClass: 'swiper-slide',
        loop: true,
    }
    var spotlightSwiper = new Swiper('#spotlight .swiper-container', {
        ...swiperParams,
        navigation: {
            nextEl: '#spotlight-next',
            prevEl: '#spotlight-prev',
        },
    });
});
